<template>
    <div class="detail">
        <div class="top-content main_content">
            <TopMenus v-model="activeIndex"></TopMenus>
        </div>
        <div class="banner-box">
            <div class="main_content banner-content">
                <div class="banner">
                    <el-carousel indicator-position="outside" arrow="always" height="338rem">
                        <el-carousel-item class="carousel-item">
                            <img src="@/views/printCenter/PiaoJu/UP380BT/images/UP380C&BT1.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="@/views/printCenter/PiaoJu/UP380BT/images/UP380C&BT2.pic.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="@/views/printCenter/PiaoJu/UP380BT/images/UP380C&BT3.pic.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="@/views/printCenter/PiaoJu/UP380BT/images/UP380C&BT4.pic.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="@/views/printCenter/PiaoJu/UP380BT/images/UP380C&BT5.pic.png" alt="img"/>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="info">
                    <div class="title">快麦<span class="other-color">UP380C</span>云小票打印机</div>
                    <div class="sub-title">WiFi配网，自动切纸</div>
                    <div class="text">
                        通讯接口：usb、钱箱、Wi-Fi<br/>
                        打印速度：max200mm/s<br/>
                        打印宽度：max104mm<br/>
                        适用：外卖、线下零售小票打印。
                    </div>
                </div>
            </div>
        </div>
        <template v-if="activeIndex===0">
            <div class="main_content content-bg">
                <img src="./images/1.jpg" alt="bg">
                <img src="./images/2.jpg" alt="bg">
                <img src="./images/3.jpg" alt="bg">
                <img src="./images/4.jpg" alt="bg">
                <img src="./images/5.jpg" alt="bg">
                <img src="./images/6.jpg" alt="bg">
                <img src="./images/7.jpg" alt="bg">
                <img src="./images/8.jpg" alt="bg">
            </div>
        </template>
        <div v-else-if="activeIndex===1" class="main_content content-bg">
            <img src="./images/cs.jpg" alt="bg">
        </div>
    </div>
</template>

<script>
import TopMenus from '@/views/printCenter/TopMenus.vue'

export default {
    name: "deviceDetail",
    components: {TopMenus},
    data() {
        return {
            activeIndex: 0
        };
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import "../../printCenter.scss";

.detail {
    .content-bg {
        img {
            width: 100%;
        }
    }
}
</style>
